import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  disclaimer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 5,
    marginBottom: 5,
  },
  ssoHeader: {
    margin: '0 0 20px 0',
    textAlign: 'center',
  },
}));

export default useStyles;
